// eslint-disable-next-line import/prefer-default-export
export const setEntityId = entityId => {
  return {
    type: 'SET_ENTITY_ID',
    payload: {
      entityId,
    },
  };
};
